import { inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, map, of, switchMap, tap } from 'rxjs'
import * as AuthActions from './authentication.actions'
import { OpenAuthenticationService } from '@core/services/oauth.service';
import { AccessService } from '@core/services/access.service';

@Injectable()
export class AuthenticationEffects {
  private actions$ = inject(Actions)

  constructor(
    private authService: OpenAuthenticationService,
    private accessService: AccessService
  ) {}

  // After login, fetch the caller's server-resolved permissions (the token is identity-only) for UI gating.
  loadPermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.loginSuccess),
      switchMap(() =>
        this.accessService.getCurrentUser().pipe(
          map((result) =>
            AuthActions.setPermissions({ permissions: result.data?.permissions ?? [] })
          ),
          catchError(() => of(AuthActions.setPermissions({ permissions: [] })))
        )
      )
    )
  );

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.login),
      tap(() => this.authService.login())
    ),
    { dispatch: false }
  );

  loginSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.loginSuccess),
      tap((value) => this.authService.getFullUserInfo(value.user, value.token))
    ),
    { dispatch: false }
  );
}
